import * as React from 'react'

function SvgEuNorms(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={31} height={31} viewBox="0 0 17 17" {...props}>
			<path
				fill="currentColor"
				d="M7.833 12.423v1.532a5.18 5.18 0 01-5.681-5.142 5.18 5.18 0 015.681-5.14v1.53a3.655 3.655 0 00-4.16 3.61 3.655 3.655 0 004.16 3.61zM10.801 8.025h2.984v1.579h-2.984a3.651 3.651 0 003.56 2.856c.174 0 .345-.012.513-.04v1.535a5.177 5.177 0 01-5.68-5.142 5.176 5.176 0 015.68-5.141v1.533a3.65 3.65 0 00-4.073 2.82z"
			/>
		</svg>
	)
}

export default SvgEuNorms
